// Tab switching from inside the overview ("לכל ההערות ←", "לציר הזמן המלא ←" …)
// via the ?tab= deep-link param. MERGE pattern (never rebuild the params) —
// the global new-signature dialog and other URL mechanisms share the search
// string. Mirrors the frozen ContactDetailTabs.handleChangeTab logic.
import { useCallback } from "react";
import { useSearchParams } from "react-router-dom";
import type { ContactDetailTabId } from "../registry";

const TAB_PARAM = "tab";
const DEFAULT_TAB: ContactDetailTabId = "overview";

export function useSwitchTab(): (tab: ContactDetailTabId) => void {
  const [searchParams, setSearchParams] = useSearchParams();
  return useCallback(
    (tab: ContactDetailTabId) => {
      const next = new URLSearchParams(searchParams);
      if (tab === DEFAULT_TAB) next.delete(TAB_PARAM);
      else next.set(TAB_PARAM, tab);
      setSearchParams(next, { replace: true });
    },
    [searchParams, setSearchParams]
  );
}
